(function () {
    'use strict';

    angular
        .module('FormBuilder')
        .directive('fbLabelRight', fbLabelRightDirective);

    function fbLabelRightDirective() {
        return {
            restrict:'E',
            transclude:true,
            scope: {
                element:'=',
                elementIdentifier: '='
            },
            templateUrl: 'common/libraries/formBuilder/fields/labelRight',
            controller: fbLabelRightDirectiveCtrl,
            controllerAs: 'vm',
            bindToController: true
        };
    }

    function fbLabelRightDirectiveCtrl($scope, FormBuilderService) {
        var vm = this;
        var formIdentifier = $scope.$parent.vm.formIdentifier;
        var fbService = null;
        this.$onInit = function() {
            fbService = FormBuilderService.get(formIdentifier);

            vm.hasError = hasError;
            vm.errorMessage = errorMessage;
        }

        function hasError() {
            return fbService.elementsService.getValidationRule(vm.elementIdentifier);
        }

        function errorMessage() {
            var error = fbService.elementsService.getValidationRule(vm.elementIdentifier);
            if (!error) {
                return '';
            }
            return error.join(' ');
        }
    }
})();